<template>
	<div :class="`mb${gap}`">
		<!-- Headline -->
		<div class="flex xs-12 xs-between">
			<div class="fs5 lh125 fw7 c1 mb2">{{ $t("actions") }}</div>
		</div>

		<!-- Mode select -->
		<div v-if="mode === 'select'">
			<div class="xs-12 flex">
				<div class="xs-9 pr4">
					<j-base-select
						v-model="form.actionId"
						:options="actions"
						:placeholder="$t('select_action')"
					/>
				</div>
				<div class="flex xs-3 xs-right">
					<j-button
						:isDisabled="form.actionId ? false : true"
						@click="$modal.show('policy_actions')"
						>{{ $t("continue") }}</j-button
					>
				</div>
			</div>
		</div>

		<!-- Mode button -->
		<div v-if="mode === 'button'">
			<div class="xs-12 flex wrap">
				<j-button
					v-for="(action, i) in actions"
					:key="i"
					size="small"
					@click="
						;(form.actionId = action.value), $modal.show('policy_actions')
					"
					class="mr2 mb2"
					>{{ action.name }}</j-button
				>
			</div>
		</div>

		<!-- Modal -->
		<core-modal name="policy_actions" :headline="computedName">
			<div class="p4">
				<component
					:is="form.actionId"
					:caseId="computedCaseId"
					:proposalId="$store.state.caseManagement.proposalId"
					@done="onDone"
				/>
			</div>
		</core-modal>
	</div>
</template>

<script>
import JBaseSelect from "@/components/JBaseSelect"
import JButton from "@/components/JButton"
import JCard from "@/components/JCard"
import CoreModal from "@/modules/core/components/CoreModal"
import ActionGetPdfFile from "./ActionGetPdfFile.vue"

export default {
	components: {
		JBaseSelect,
		JButton,
		JCard,
		CoreModal,
		ActionGetPdfFile
	},

	props: {
		actions: {
			type: Array,
			default: () => [
				{
					name: "Get PDF File",
					value: "ActionGetPdfFile"
				}
			]
		},
		/**
		 * How to display actions
		 * mode === "select" - it will display select box
		 * mode === "button" - it will display buttons
		 */
		mode: {
			validator(val) {
				return ["select", "button"].includes(val)
			},
			default: "button"
		},

		/**
		 * Vertical gap between fields
		 * It translates into mb{gap} class
		 */
		gap: {
			type: String,
			default: "4"
		}
	},

	data() {
		return {
			form: {
				actionId: null
			}
		}
	},

	computed: {
		computedName() {
			return this.actions?.find(item => item.value === this.form.actionId)?.name
		},

		/**
		 * If policyId is provided via prop, use it, otherwise take it from route
		 */
		computedCaseId() {
			return this.caseId ? this.caseId : this.$route.params.id
		}
	},

	methods: {
		onDone() {
			// Hide modal after timeout
			setTimeout(() => this.$modal.hide("policy_actions"), 250)

			// Show success message
			this.$store.dispatch("addMessage", {
				delay: 900,
				message: {
					type: "success",
					text: "Action was successful, yay!"
				}
			})
		}
	}
}
</script>
